import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import { tokenService } from '@/services/tokenService'
import * as authAPI from '@/api/auth'

/**
 * Hook to initialize auth state from localStorage on app startup
 */
export function useAuthInit() {
  const { setUser, setTokens, setLoading } = useAuthStore()

  useEffect(() => {
    const initializeAuth = async () => {
      setLoading(true)

      try {
        // Check for existing tokens
        const accessToken = await tokenService.getAccessToken()
        const refreshToken = await tokenService.getRefreshToken()

        if (accessToken && refreshToken) {
          // Restore tokens to store
          setTokens(accessToken, refreshToken)

          // Try to fetch user data
          try {
            const meResult = await authAPI.getMe()
            if (meResult.success && meResult.data) {
              await tokenService.saveUserData(meResult.data)
              setUser(meResult.data)
            } else {
              // If getMe fails, try to restore from localStorage
              const savedUser = await tokenService.getUserData()
              if (savedUser) {
                setUser(savedUser)
              }
            }
          } catch (error) {
            // If getMe fails, try to restore from localStorage
            const savedUser = await tokenService.getUserData()
            if (savedUser) {
              setUser(savedUser)
            }
          }
        } else {
          // No tokens, check for saved user data (shouldn't happen, but just in case)
          const savedUser = await tokenService.getUserData()
          if (savedUser) {
            // Clear invalid user data if no tokens
            await tokenService.clearTokens()
          }
        }
      } catch (error) {
        console.error('Auth initialization error:', error)
        // Clear potentially corrupted data
        await tokenService.clearTokens()
      } finally {
        setLoading(false)
      }
    }

    initializeAuth()
  }, [setUser, setTokens, setLoading])
}
